import deviceType from 'scoreboard/components/device-type'
import Backbone from 'backbone'
import _ from 'lodash'

// stores the first language that was sent in the Accept-Language header.  There
// is no other way to retrieve this value in JavaScript, so we have to depend
// on the server sending it back to us.
var requestLanguage

var overrideLocale

/**
 * Returns information about the browser's locale, e.g.
 *
 * { locale: 'en-US', language: 'en', country: 'us' }
 */
function getBrowserLocale() {
	if (overrideLocale) {
		return forStr(overrideLocale)
	}

	// read locale from the browser
	var language = navigator.language
	// https://alicoding.com/detect-browser-language-preference-in-firefox-and-chrome-using-javascript/
	if (deviceType.chrome) {
		// Electron Chrome (for exports) will always use the OS language.
		// So for exports the language passed in 'Accept-Language' is provided in globals
		language = navigator.languages[0] ? navigator.languages[0] : requestLanguage
	}

	return forStr(language)
}

/**
 * Returns information about a locale based on a pre-formatted locale string
 * with a format like this: 'en-US'.  Intended for testing
 */
function forStr(locale) {
	var split = locale.replace('-', '_').toLowerCase().split('_')
	var country = split.length === 2 && split[1]
	var answer = {
		locale: locale,
		language: split[0]
	}
	if (country) {
		answer.country = country
	}
	return answer
}

Backbone.on('load', function(data) {
	requestLanguage = data.language
})

/**
 * For unit tests only: override the browser's locale
 */
function set (locale) {
	overrideLocale = locale
}

_.extend(getBrowserLocale, {
	forStr,
	set
})
export default getBrowserLocale
export { forStr }
export { set }

getBrowserLocale.__filename__ = 'components/locale.js'
